import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';

function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}
function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}
const dateComparatorAsc = (a, b) => {
  const toTime = (v) => {
    if (!v) return Number.POSITIVE_INFINITY; // null/empty last on asc
    const t = new Date(v).getTime();
    return Number.isNaN(t) ? Number.POSITIVE_INFINITY : t;
  };
  return toTime(a) - toTime(b);
};
export const ManufactureTableHead = [
  {
    headerName: 'Select All',
    maxWidth: 135,
    filter: false,
    hideFilterIcon: true,
    checkboxSelection: true, // For rows checkbox
    headerCheckboxSelection: true, // For header check box
    cellStyle: { borderRightColor: Styles.BorderColor },
    // field: "checkSelect",
    editable: false,
    suppressMenu: false,
    sortable: false,
  },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sort: 'asc',
    minWidth: Styles.Width_200,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellRenderer: 'TextBoxRender',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

const cellRenderer = (cellInfo) => {
  const unallocatedBalanceAmt = cellInfo?.data?.unallocatedBalanceAmt;

  // Extract the numerical part from the value
  const numericalValue = parseFloat(
    unallocatedBalanceAmt?.toString().replace(/[^0-9.-]/g, '') // Remove non-numeric characters except '-' and '.'
  );

  // Format the numerical value with commas and a '$' sign, adding a space between them
  const formattedValue = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericalValue < 0 ? -numericalValue : numericalValue);

  // Add a space after the $ sign
  const valueWithSpace = formattedValue.replace('$', '$ ');

  // Check if the numerical value is negative
  const isNegativeVal = numericalValue < 0;

  return (
    <>
      {isNegativeVal ? (
        <div style={{ color: '#eb0000' }}>{`(${valueWithSpace})`}</div>
      ) : (
        <div>{valueWithSpace}</div>
      )}
    </>
  );
};

export const UnallocatedBalanceReportTableHead = [
  {
    headerName: 'Unallocated Balance Amount',
    field: 'unallocatedBalanceAmt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_190,
    maxWidth: Styles.Width_200,
    cellRenderer,
    comparator: amountComparator,
    alignment: 'right',
    isTextColorRed: true,
    printPrefixValue: '$',
    exportZeroesTwo: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    //sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Balance Type',
    field: 'balanceTypeCd',
    editable: false,
    suppressMenu: false,
    sortable: true,
    cellClass: 'frr-ellipsis-text',
    minWidth: Styles.Width_200,
    cellRenderer: 'TextBoxRender',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Original Check Log Number',
    field: 'origCheckLogNum',
    editable: false,
    suppressMenu: false,
    excelAlignment: 'right',
    sortable: true,
    minWidth: Styles.Width_171,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Original Check Received Date',
    field: 'origReceivedDt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sort: 'asc',
    sortIndex: 1, 
    comparator: dateComparatorAsc,
    minWidth: Styles.Width_167,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Original Check Issuer',
    field: 'origCheckIssuer',
    editable: false,
    suppressMenu: false,
    sortable: true,

    minWidth: Styles.Width_230,
    cellRenderer: 'TextBoxRender',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    cellClass: 'frr-ellipsis-text',
    filter: 'agTextColumnFilter',
    columnSpan: 2,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Allocated Check Log Number',
    field: 'allocatedCheckLogNum',
    editable: false,
    suppressMenu: false,
    excelAlignment: 'right',
    sortable: true,
    minWidth: Styles.Width_180,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
  },
  {
    headerName: 'Allocated Check Received Date',
    field: 'allocatedReceivedDt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sort: 'asc', 
    sortIndex: 1,
    comparator: dateComparatorAsc,
    minWidth: Styles.Width_180,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
